import {
  Component,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Store, Select } from '@ngxs/store';
import {
  BaseComponent,LocationState,VenueManagementState
} from '@moduurnv2/libs-orderingapp/src';
import { ModalService } from '@moduurnv2/web/features/ui/components/modal/modal.service';
import { SetCustomerPerTable } from '@moduurnv2/libs-orderingapp/src/core';
import { Router } from '@angular/router';
import { ThemeOptions } from '@moduurnv2/features/ui/directives';
@Component({
  selector: 'wj-person-count',
  templateUrl: './wj-person-count.component.html',
  styleUrls: ['./wj-person-count.component.scss'],
})
export class WJPersonCountComponent extends BaseComponent implements OnInit {
  @ViewChild('customerCount') guestCount: ElementRef;
  numbers = new RegExp(/^[0-9]*$/);
  _modalClose: any = null;
  _data: any = null;
  isHavingValue:boolean=false;
  personCount : number ;
  set modalClose(modalRef: any) {
    this._modalClose = (data) => {
      this.modal.closeComponentModal(modalRef, data);
    };
  }

  selectedTimeDate = {
    date: null,
    time: null,
  };
  themeOptions: ThemeOptions = {
    appFontFamily:true
  };

  constructor(private store: Store, private modal: ModalService,public router: Router) {
    super();
  }
  ngOnInit() {}
  clearvalue() {
    this.personCount = undefined;
  }
  backToHome() {
    this.modal.closeAllModals();
  }

  personCountSubmit(value) {
    let selectedLocation = this.store.selectSnapshot(
      LocationState.getSelectedLocation
    );

    if(value && parseInt(value)>0) {
    const PersonCount = {
      count:parseInt(value)
    }
    this.isHavingValue = false;
    this.store.dispatch(new SetCustomerPerTable(PersonCount));
    this.modal.closeAllModals();
    this.router.navigate([`/locations/${selectedLocation._id}/menu`]);
  } else {
    this.isHavingValue = true;
    this.guestCount.nativeElement.focus();
  }
  }

  checkFormat(event) {
    if (!this.numbers.test(event.target.value)) {
      return (event.target.value = '');
    } else if(event.target.value>0) {
      console.log('focused');
      this.guestCount.nativeElement.focus();
      this.isHavingValue = false;
      if(event.keyCode == 13) {
        this.personCountSubmit(this.personCount);
      }
    }
  }
  set data(data: any) {
    this._data = data;
  }
}
